/* Seoden London — theme interactions */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---- Mobile hamburger ---- */
    var burger = document.querySelector('[data-burger]');
    var mobmenu = document.querySelector('[data-mobmenu]');
    if (burger && mobmenu) {
      burger.addEventListener('click', function () {
        mobmenu.classList.toggle('is-open');
      });
    }

    /* ---- Hero carousel ---- */
    (function () {
      var hero = document.querySelector('[data-hero]');
      if (!hero) return;
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      if (!slides.length) return;
      var idx = 0, timer;
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.style.opacity = i === idx ? '1' : '0';
          s.style.pointerEvents = i === idx ? 'auto' : 'none';
        });
        dots.forEach(function (d, i) {
          d.style.background = i === idx ? '#161616' : 'rgba(22,22,22,0.3)';
        });
      }
      function next() { show(idx + 1); }
      function prev() { show(idx - 1); }
      function restart() { clearInterval(timer); timer = setInterval(next, 5000); }
      hero.querySelectorAll('[data-hero-next]').forEach(function (b) { b.addEventListener('click', function () { next(); restart(); }); });
      hero.querySelectorAll('[data-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { prev(); restart(); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); restart(); }); });
      show(0); restart();
    })();

    /* ---- Horizontal sliders (best sellers / related) ---- */
    document.querySelectorAll('[data-slider-wrap]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-slider]');
      if (!track) return;
      wrap.querySelectorAll('[data-slide-next]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
      });
      wrap.querySelectorAll('[data-slide-prev]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
      });
    });

    /* ---- Reviews carousel (transform loop) ---- */
    (function () {
      var track = document.querySelector('[data-rev-track]');
      if (!track) return;
      var wrap = track.closest('[data-rev-wrap]');
      var cIdx = 0, busy = false;
      function setX(anim) {
        track.style.transition = anim ? 'transform .5s cubic-bezier(.4,0,.2,1)' : 'none';
        track.style.transform = 'translateX(-' + (cIdx * 6.25) + '%)';
      }
      function next() {
        if (busy) return; busy = true;
        cIdx += 1; setX(true);
        setTimeout(function () { if (cIdx >= 8) { cIdx = 0; setX(false); } busy = false; }, 520);
      }
      function prev() {
        if (busy) return; busy = true;
        if (cIdx <= 0) { cIdx = 8; setX(false); }
        setTimeout(function () { cIdx -= 1; setX(true); setTimeout(function () { busy = false; }, 520); }, 30);
      }
      wrap.querySelectorAll('[data-rev-next]').forEach(function (b) { b.addEventListener('click', next); });
      wrap.querySelectorAll('[data-rev-prev]').forEach(function (b) { b.addEventListener('click', prev); });
      setX(false);
    })();

    /* ---- Product: thumbnail strip arrows ---- */
    document.querySelectorAll('[data-thumb-wrap]').forEach(function (w) {
      var strip = w.querySelector('[data-thumbs]');
      if (!strip) return;
      function thumbScroll(dir){ if (strip.scrollWidth > strip.clientWidth + 2) strip.scrollBy({ left: dir * strip.clientWidth * 0.9, behavior: 'smooth' }); else strip.scrollBy({ top: dir * strip.clientHeight * 0.8, behavior: 'smooth' }); }
      w.querySelectorAll('[data-thumb-next]').forEach(function (b) { b.addEventListener('click', function () { thumbScroll(1); }); });
      w.querySelectorAll('[data-thumb-prev]').forEach(function (b) { b.addEventListener('click', function () { thumbScroll(-1); }); });
    });

    /* Адрес фото с нужной шириной: свой width вместо чужого или оригинала. */
    function sdImgW(u, w) {
      if (!u) return u;
      if (u.indexOf('//') === 0) u = 'https:' + u;
      u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    /* Ступенька ширины под фактический размер блока и плотность экрана. */
    function sdPickW(el) {
      var need = (el.getBoundingClientRect().width || 400) * (window.devicePixelRatio || 1);
      var steps = [400, 600, 800, 1000, 1400];
      for (var i = 0; i < steps.length; i++) { if (steps[i] >= need) return steps[i]; }
      return 1400;
    }

    /* ---- Product: thumbnail gallery ---- */
    (function () {
      var main = document.querySelector('[data-gallery-main]');
      if (!main) return;
      document.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var url = t.getAttribute('data-img');
          if (url) {
            if (main.tagName === 'IMG') { main.removeAttribute('srcset'); main.src = sdImgW(url, sdPickW(main)); }
            else { main.style.backgroundImage = "url('" + sdImgW(url, sdPickW(main)) + "')"; }
          }
          document.querySelectorAll('[data-thumb]').forEach(function (x) { x.style.borderColor = '#E6E4DF'; });
          t.style.borderColor = '#161616';
        });
      });
    })();

    /* ---- Product: accordions ---- */
      document.querySelectorAll('[data-acc-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.nextElementSibling;
          var open = panel.style.display !== 'none';
          document.querySelectorAll('[data-acc-panel]').forEach(function (p) { p.style.display = 'none'; });
          document.querySelectorAll('[data-acc-icon]').forEach(function (i) { i.textContent = '+'; });
          if (!open) { panel.style.display = 'block'; btn.querySelector('[data-acc-icon]').textContent = '–'; }
          btn.scrollIntoView({ block: 'start' });
        });
      });

    /* ---- Product: buy total (bundle total + optional protection) ---- */
    function recalcBuyTotal() {
      var qtyInput = document.querySelector('[data-qty-input]');
      var buyTotalAmount = document.querySelector('[data-buy-total-amount]');
      var protectBtn = document.querySelector('[data-protect]');
      if (!qtyInput || !buyTotalAmount) return;
      var baseCents = parseInt(qtyInput.getAttribute('data-total-cents') || '0', 10);
      var protectOn = protectBtn && protectBtn.getAttribute('aria-pressed') === 'true';
      var protectCents = protectOn ? parseInt(protectBtn.getAttribute('data-protect-price-cents') || '0', 10) : 0;
      var totalCents = baseCents + protectCents;
      buyTotalAmount.textContent = '£' + (totalCents / 100).toFixed(2);
    }

    /* ---- Product: подпись над названием ----
       07.09.2026: подпись берётся из product.type. По каталогу проверено: у 71 товара
       там лежит заводской код (PK09, PK17, C21, A08, Q15, SJ17), ещё у 58 поле пустое
       и Liquid подставляет слово «Collection». То есть 129 карточек из 196 показывают
       покупателю мусор вместо категории — включая рекламируемое худи, где над названием
       стояло «PK09».

       Чинить поле у каждого товара бессмысленно: при следующем заливе коды вернутся.
       Поэтому решаем в теме — если в поле код или пусто, подпись просто убираем.
       Категория и так видна в хлебных крошках строкой выше, так что ничего не теряется,
       а новые товары обрабатываются сами. */
    (function () {
      var root = document.querySelector('[data-product-form]');
      if (!root || !window.__seodenProduct) return;
      var h1 = root.querySelector('h1');
      var eyebrow = h1 && h1.previousElementSibling;
      if (!eyebrow) return;
      var t = (window.__seodenProduct.type || '').trim();
      /* код = одна-три буквы и одна-три цифры: PK09, C21, A8, SJ17 */
      var looksLikeCode = /^[A-Za-z]{1,3}[-\s]?\d{1,3}$/.test(t);
      if (!t || looksLikeCode || eyebrow.textContent.trim() === 'Collection') {
        eyebrow.style.display = 'none';
      }
    })();

    /* ---- Product: bundle-embedded variant pickers + gallery sync ---- */
    (function () {
      var root = document.querySelector('[data-product-form]');
      if (!root || !window.__seodenProduct) return;
      var product = window.__seodenProduct;
      var activePicker = null;

      function variantForSelection(sel) {
        var keys = Object.keys(sel);
        if (!keys.length) return product.variants[0];
        return product.variants.find(function (v) {
          return keys.every(function (i) { return v.options[i] === sel[i]; });
        });
      }

      function formatMoney(cents) {
        return '£' + (cents / 100).toFixed(2);
      }

      function syncGalleryImage(v) {
        if (!v || !v.featured_image || !v.featured_image.src) return;
        var url = v.featured_image.src;
        if (url.indexOf('//') === 0) url = 'https:' + url;
        var main = document.querySelector('[data-gallery-main]');
        if (main) {
          var sized = sdImgW(url, sdPickW(main));
          if (main.tagName === 'IMG') {
            // То же фото другого размера не перекачиваем (12.10.2026: при открытии карточки главное фото грузилось второй раз в 1400)
            var path = function (u) { return (u || '').replace(/^https?:/, '').split('?')[0]; };
            if (path(main.currentSrc || main.src) !== path(sized)) { main.removeAttribute('srcset'); main.src = sized; }
          } else { main.style.backgroundImage = "url('" + sized + "')"; }
        }
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.style.borderColor = (t.getAttribute('data-img') === url) ? '#161616' : '#E6E4DF';
        });
      }

      function readRowSelection(row) {
        var sel = {};
        row.querySelectorAll('[data-bundle-select]').forEach(function (s) {
          sel[s.getAttribute('data-bundle-option-index')] = s.value;
        });
        return sel;
      }

      /* 07.09.2026: селекторы рендерятся из product.options_with_values, то есть
         предлагают ВСЕ значения каждой опции. Реальных вариантов меньше: у худи
         Fleece-Lined существует только для Leopard Print, у Classic Full-Zip
         недостижимы 79 комбинаций из 165. Раньше человек узнавал об этом только
         после клика Buy it now — из общей ошибки, без подсказки, что менять.
         Здесь недостижимые значения гасятся заранее, каскадом слева направо:
         опция 1 всегда открыта целиком, опция 2 фильтруется по выбору опции 1,
         опция 3 — по выбору опций 1 и 2. Если текущее значение стало
         недостижимым, оно само переезжает на первое доступное. */
      function refreshRowAvailability(row) {
        var selects = row.querySelectorAll('[data-bundle-select]');
        var moved = false;
        for (var i = 0; i < selects.length; i++) {
          var prefix = [];
          for (var k = 0; k < i; k++) prefix.push(selects[k].value);
          var firstEnabled = null;
          for (var j = 0; j < selects[i].options.length; j++) {
            var opt = selects[i].options[j];
            var candidate = prefix.concat(opt.value);
            var reachable = product.variants.some(function (v) {
              if (!v.available) return false;
              for (var q = 0; q < candidate.length; q++) {
                if (v.options[q] !== candidate[q]) return false;
              }
              return true;
            });
            opt.disabled = !reachable;
            if (reachable && firstEnabled === null) firstEnabled = opt.value;
          }
          var current = selects[i].options[selects[i].selectedIndex];
          if (firstEnabled !== null && (!current || current.disabled)) {
            selects[i].value = firstEnabled;
            moved = true;
          }
        }
        return moved;
      }

      function refreshPickerAvailability(picker) {
        if (!picker) return;
        picker.querySelectorAll('[data-bundle-item]').forEach(function (row) {
          refreshRowAvailability(row);
        });
      }

      function activeTierButton() {
        var wrap = activePicker && activePicker.closest('[data-bundle-wrap]');
        return wrap ? wrap.querySelector('[data-bundle]') : null;
      }

      /* цена внутри карточки уровня: последний <span> в правой колонке кнопки
         (перед ним может стоять зачёркнутая compare-at) */
      function tierPriceEl(b) {
        var col = b.querySelector('span[style*="text-align:right"]');
        return col ? col.querySelector('span:last-child') : null;
      }

      /* зачёркнутая «было» — первый span правой колонки, есть не всегда */
      function tierCompareEl(b) {
        var col = b.querySelector('span[style*="text-align:right"]');
        if (!col) return null;
        var spans = col.querySelectorAll('span');
        return spans.length > 1 ? spans[0] : null;
      }

      /* 07.09.2026: сумма на кнопке считалась в Liquid как
         product.price × qty × (1 − скидка), то есть от БАЗОВОЙ цены товара.
         У худи Fleece-Lined стоит £69.80 против £49.80 у Classic — кнопка обещала
         £49.80, а чекаут списывал £69.80 (на Buy 2 расхождение доходило до £18).
         Считаем от реальных цен выбранных вариантов. Процент скидки не хардкодим:
         достаём его из уже посчитанного Liquid значения через
         ratio = data-total-cents / (product.price × qty) — так любые правки
         скидок в редакторе тем продолжают работать сами. */
      function recalcSelectedTotal() {
        var qtyInput = document.querySelector('[data-qty-input]');
        var tier = activeTierButton();
        if (!qtyInput || !tier || !activePicker) return;
        var base = product.price || 0;

        function ratioFor(b) {
          var q = parseInt(b.getAttribute('data-qty') || '1', 10);
          var baked = parseInt(b.getAttribute('data-total-cents') || '0', 10);
          return (base && q) ? (baked / (base * q)) : 1;
        }

        var rows = activePicker.querySelectorAll('[data-bundle-item]');
        var sum = 0;
        for (var i = 0; i < rows.length; i++) {
          var v = variantForSelection(readRowSelection(rows[i]));
          sum += v ? v.price : base;
        }
        var total = Math.round(sum * ratioFor(tier));
        qtyInput.setAttribute('data-total-cents', String(total));

        /* цены на карточках уровней — от цены выбранного варианта, иначе они
           разойдутся с кнопкой и мы получим ту же ошибку, только в другом месте */
        var row1 = activePicker.querySelector('[data-bundle-item]');
        var v1 = row1 ? variantForSelection(readRowSelection(row1)) : null;
        var unit = v1 ? v1.price : base;
        var unitCompare = (v1 && v1.compare_at_price) ? v1.compare_at_price : 0;
        document.querySelectorAll('[data-bundle]').forEach(function (b) {
          var el = tierPriceEl(b);
          if (!el) return;
          var q = parseInt(b.getAttribute('data-qty') || '1', 10);
          var shown = (b === tier) ? total : Math.round(unit * q * ratioFor(b));
          el.textContent = formatMoney(shown);

          /* «было £X» тоже от выбранного варианта: у Fleece-Lined своя compare-at.
             Если зачёркнутая цена не выше текущей — прячем, чтобы не показывать
             бессмысленную «скидку» в ноль или в минус. */
          var cmp = tierCompareEl(b);
          if (!cmp) return;
          var cmpTotal = unitCompare * q;
          if (cmpTotal > shown) {
            cmp.textContent = formatMoney(cmpTotal);
            cmp.style.display = '';
          } else {
            cmp.style.display = 'none';
          }
        });
      }

      /* row #1 of the currently active bundle tier drives the top price/id/gallery */
      function updatePrimaryFromActivePicker() {
        if (!activePicker) return;
        var row1 = activePicker.querySelector('[data-bundle-item]');
        var v = row1 ? variantForSelection(readRowSelection(row1)) : product.variants[0];
        var idInput = root.querySelector('input[name="id"]');
        var priceEl = root.querySelector('[data-price]');
        var btn = root.querySelector('[data-add]');
        if (v) {
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.textContent = formatMoney(v.price);
          /* 22.10.2026: зачёркнутая и % скидки — от того же варианта, что и цена (Rosalie: у видов разные цены);
             плашка % на фото стоит вне формы — ищем по всей странице */
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          document.querySelectorAll('[data-compare]').forEach(function (el) {
            el.textContent = onSale ? formatMoney(v.compare_at_price) : '';
            el.style.display = onSale ? '' : 'none';
          });
          document.querySelectorAll('[data-off]').forEach(function (el) {
            el.textContent = onSale ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '% OFF' : '';
            el.style.display = onSale ? '' : 'none';
          });
          if (btn) {
            if (v.available) { btn.removeAttribute('disabled'); btn.style.opacity = '1'; }
            else { btn.setAttribute('disabled', 'disabled'); btn.style.opacity = '.5'; }
          }
          syncGalleryImage(v);
        }
      }

      document.querySelectorAll('[data-bundle-select]').forEach(function (sel) {
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        sel.addEventListener('change', function () {
          var row = sel.closest('[data-bundle-item]');
          var picker = sel.closest('[data-bundle-picker]');
          if (picker !== activePicker) return;
          refreshRowAvailability(row);
          var firstRow = picker.querySelector('[data-bundle-item]');
          if (row === firstRow) updatePrimaryFromActivePicker();
          recalcSelectedTotal();
          recalcBuyTotal();
        });
      });

      /* ---- Product: bundle tier selection (Buy 1 / Buy 2 / Buy 3) ---- */
      var bundles = document.querySelectorAll('[data-bundle]');
      function selectBundle(b) {
        bundles.forEach(function (x) {
          var wrap = x.closest('[data-bundle-wrap]');
          if (wrap) { wrap.style.borderColor = '#E2DFD9'; wrap.style.background = '#fff'; }
          var dot = x.querySelector('[data-bundle-dot]');
          var fill = x.querySelector('[data-bundle-fill]');
          if (dot) dot.style.borderColor = '#C9C5BD';
          if (fill) fill.style.background = 'transparent';
          var picker = wrap && wrap.querySelector('[data-bundle-picker]');
          if (picker) picker.style.display = 'none';
        });
        var activeWrap = b.closest('[data-bundle-wrap]');
        if (activeWrap) { activeWrap.style.borderColor = '#1FA463'; activeWrap.style.background = '#EEF7F1'; }
        var d = b.querySelector('[data-bundle-dot]');
        var f = b.querySelector('[data-bundle-fill]');
        if (d) d.style.borderColor = '#1FA463';
        if (f) f.style.background = '#1FA463';
        var qtyInput = document.querySelector('[data-qty-input]');
        if (qtyInput && b.getAttribute('data-qty')) qtyInput.value = b.getAttribute('data-qty');
        if (qtyInput && b.getAttribute('data-total-cents')) qtyInput.setAttribute('data-total-cents', b.getAttribute('data-total-cents'));
        activePicker = activeWrap && activeWrap.querySelector('[data-bundle-picker]');
        if (activePicker) activePicker.style.display = 'block';
        refreshPickerAvailability(activePicker);
        updatePrimaryFromActivePicker();
        recalcSelectedTotal();
        var errorEl = document.querySelector('[data-bundle-error]');
        if (errorEl) errorEl.style.display = 'none';
        recalcBuyTotal();
      }
      if (bundles.length) {
        bundles.forEach(function (b) {
          b.addEventListener('click', function () { selectBundle(b); });
        });
        var defaultBundle = document.querySelector('[data-bundle][data-default="1"]') || bundles[0];
        selectBundle(defaultBundle);
      }

      /* ---- Product: shipping protection toggle ---- */
      (function () {
        var p = document.querySelector('[data-protect]');
        if (!p) return;
        var on = false;
        function paint() {
          var box = p.querySelector('[data-protect-box]');
          box.style.background = on ? '#1FA463' : 'transparent';
          box.style.borderColor = on ? '#1FA463' : '#C9C5BD';
          box.textContent = on ? '✓' : '';
          p.style.background = on ? '#EEF7F1' : '#FBF1E8';
          p.style.borderColor = on ? '#BFE3CC' : '#F0D9C4';
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        p.addEventListener('click', function () {
          on = !on;
          paint();
          recalcBuyTotal();
        });
        paint();
      })();

      /* ---- Product form: add every bundle unit (own color/size) + optional protection via AJAX ---- */
      var form = document.getElementById('deoden-product-form');
      var protectBtn = document.querySelector('[data-protect]');
      var errorEl = document.querySelector('[data-bundle-error]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (errorEl) errorEl.style.display = 'none';
          var qtyInput = document.querySelector('[data-qty-input]');
          var qty = parseInt((qtyInput && qtyInput.value) || '1', 10);
          var items = [];
          if (activePicker) {
            var rows = activePicker.querySelectorAll('[data-bundle-item]');
            for (var i = 0; i < rows.length; i++) {
              var row = rows[i];
              var n = row.getAttribute('data-bundle-unit');
              var v = variantForSelection(readRowSelection(row));
              if (!v || !v.available) {
                if (errorEl) { errorEl.textContent = 'Item ' + n + ': please pick a different color/size — that combination is not available.'; errorEl.style.display = 'block'; }
                return;
              }
              items.push({ id: v.id, quantity: 1 });
            }
          } else {
            var only = product.variants[0];
            if (!only || !only.available) {
              if (errorEl) { errorEl.textContent = 'This product is currently unavailable.'; errorEl.style.display = 'block'; }
              return;
            }
            for (var j = 0; j < qty; j++) items.push({ id: only.id, quantity: 1 });
          }
          var protectionVariantId = protectBtn ? protectBtn.getAttribute('data-protect-variant') : '';
          var protectionOn = protectBtn && protectBtn.getAttribute('aria-pressed') === 'true';
          if (protectionOn && protectionVariantId) items.push({ id: protectionVariantId, quantity: 1 });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error((d && d.description) || 'cart add failed'); });
            window.location.href = '/checkout';
          }).catch(function () {
            if (errorEl) { errorEl.textContent = 'Something went wrong adding this to your cart — please try again.'; errorEl.style.display = 'block'; }
          });
        });
      }
    })();
  });
})();
